import { NgModule } from "@angular/core";
import { CommonModule, DatePipe } from "@angular/common";
import { ReactiveFormsModule } from "@angular/forms";
import { NgSelectModule } from '@ng-select/ng-select';
import { SharedModule } from "src/app/shared/shared.module";
import { InadimplenciaRoutingModule } from "./inadimplencia-routing.module";
import { InadimplenciaListagemComponent } from "./pesquisa/listagem/inadimplencia-listagem.component";
import { InadimplenciaPesquisaComponent } from "./pesquisa/inadimplencia-pesquisa.component";
import { InadimplenciaCadastroComponent } from "./cadastro/inadimplencia-cadastro.component";

@NgModule({
    declarations:[
        InadimplenciaPesquisaComponent,
        InadimplenciaListagemComponent,
        InadimplenciaCadastroComponent,
    ],
    imports:[
        CommonModule,
        SharedModule,
        ReactiveFormsModule,
        InadimplenciaRoutingModule,
        NgSelectModule
    ],
    providers:[DatePipe]

})
export class InadimplenciaModule{}

